<template>
    <div class="star-rating">
        <span style="height: 18px;">
        <span style="height: 14px; margin-right: 6px; margin-top: 2px;">{{this.rating}}</span>
        </span><div v-for="index in 5" :key="index" class="star-container">
        <svg width="18" height="18" viewBox="0 0 24 24">
          <defs>
            <linearGradient :id="'grad' + index + '' + fillAmount(index)">
              <stop offset="0%" stop-color="#ffa41c" stop-opacity="1" />
              <stop :offset="fillAmount(index) + '%'" stop-color="#ffa41c" stop-opacity="1" />
              <stop :offset="fillAmount(index) + '%'" stop-color="white" stop-opacity="0" />
              <stop offset="100%" stop-color="white" stop-opacity="0" />
            </linearGradient>
          </defs>
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.46 4.73L5.82 21z"
            :fill="'url(#grad' + index + '' + fillAmount(index) + ')'"
            stroke="#de7921"
            stroke-width="1.8"
          />
        </svg>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StarRating',
    props: {
      rating: {
        type: String,
        required: true
      }
    },
    computed: {
      floatRating() {
        return parseFloat(this.rating);
      }
    },
    methods: {
      fillAmount(index) {
        const fullStars = Math.floor(this.floatRating);
        const partial = this.floatRating % 1;
        if (index <= fullStars) {
          return 100;
        } else if (index === fullStars + 1) {
          return partial * 100;
        } else {
          return 0;
        }
      },
      stopOpacity(index, partial) {
        return index <= Math.ceil(this.floatRating) ? 1 : partial ? partial : 0.2;
      }
    }
  }
  </script>
  
  <style>
  .star-container {
    display: inline-block;
    margin-right: 1px;
  }
  .star-rating {
    margin-bottom: 5px;
  }
  </style>